'use client';

import React from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

type MenuLinkProps = {
  href: string;
  label: string;
  variant?: 'desktop' | 'mobile';
  onClick?: () => void;
};

const variantStyles = {
  desktop: 'text-base hover:underline bg-transparent border-none cursor-pointer underline-offset-4',
  mobile: 'text-2xl hover:underline underline-offset-4',
};

export const MenuLink = ({
  href,
  label,
  variant = 'desktop',
  onClick,
}: MenuLinkProps) => {
  const pathname = usePathname();

  // Remove query parameters from href for comparison
  const hrefPath = href.split('?')[0];

  // Check if the current path matches this link
  // For root paths like '/' or '/ru', do exact match
  // For other paths, check if pathname starts with href
  const isActive =
    hrefPath === '/' || hrefPath === '/ru'
      ? pathname === hrefPath
      : pathname.startsWith(hrefPath);

  const baseStyles = variantStyles[variant];
  const activeStyles = isActive ? 'underline' : '';

  return (
    <Link
      href={href}
      onClick={onClick}
      className={`${baseStyles} ${activeStyles}`}
    >
      {label}
    </Link>
  );
};
